import { createApp } from 'vue/dist/vue.esm-bundler';
import _ from 'lodash';
import QuestionsForm from '../components/questions-form';
import QuestionsTab from '../components/questions-tab';
import QuestionsTabError from '../components/questions-tab-error';
import ProfitAndLossForm from '../components/profit-and-loss-form';
import ProfitAndLossFormV5 from '../components/profit-and-loss-form-v5';
import ModalWrapper from '../components/modal-wrapper';
import ModalView from '../components/modal-view';
import ModalViewSp from '../components/modal-view-sp';
import CountableField from '../components/countable-field';
import TrainingViewer from '../components/training-viewer';
import TrainingViewerSp from '../components/training-viewer-sp';
import ThemeQuestionsForm from '../components/theme-questions-form';
import ThemeQuestionsSidebar from '../components/theme-questions-sidebar';
import ThemeQuestionsSidebarError from '../components/theme-questions-sidebar-error';

window.QuestionsTab =  {
  'QuestionsTab': QuestionsTab,
  'createApp' : createApp,
  'app': null
}
window.ThemeQuestionsSidebar =  {
  'ThemeQuestionsSidebar': ThemeQuestionsSidebar,
  'createApp' : createApp,
  'app': null
}
window.ModalView = createApp({ components: {'modal-view': ModalView} })
window.ModalViewSp = createApp({ components: {'modal-view-sp': ModalViewSp} })

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('main') || document.getElementById('main')
  if (el) {
    const app = createApp({
      compilerOptions: {
        isCustomElement: (tag) => tag === 'text-counter',
      },
      data() {
        return {
          forceRerender: false,
          pcMode: document.body.dataset.mode === 'pc',
          children: []
        };
      },
      methods: {
        onFormChange(form, callee) {
          this.children.forEach((child) => {
            if (callee !== child) {
              child.onFormChange && child.onFormChange(form);
            }
          });
        },
        handleResize: _.throttle(() => {
          if (window !== window.parent) {
            this.forceRerender = true;
            this.$nextTick(() => {
              this.forceRerender = false;
            });
          }
        }, 1000, { trailing: false }),
        openModal(elementId, e) {
          this.modalProps = {};
          if (e && e.currentTarget.dataset.props) {
            this.modalProps = JSON.parse(e.currentTarget.dataset.props);
          }
          this.$refs.modalWrapper.openModalViewByElementId(elementId);
        },
        closeModal() {
          this.$refs.modalWrapper.closeModalView();
        },
        getChildren() {
          const children = []
          const keys = Object.keys(this.$refs)
          for ( let i = 0; i < keys.length; i++) {
            const key = keys[i]
            children.push(this.$refs[key])
          }
          return children
        },
        },
      computed: {
        spMode() {
          return !this.pcMode;
        },
      },
      mounted() {
        this.children = this.getChildren()
        window.addEventListener('resize', this.handleResize);
      },
      beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
      },
      components: {
        'questions-form': QuestionsForm,
        'profit-and-loss-form': ProfitAndLossForm,
        'profit-and-loss-form-v5': ProfitAndLossFormV5,
        'countable-field': CountableField,
        'training-viewer': TrainingViewer,
        'training-viewer-sp': TrainingViewerSp,
        'theme-questions-form': ThemeQuestionsForm,
        'theme-questions-sidebar': ThemeQuestionsSidebar,
        'theme-questions-sidebar-error': ThemeQuestionsSidebarError,
        'questions-tab': QuestionsTab,
        'questions-tab-error': QuestionsTabError,
        'modal-view': ModalView,
        'modal-view-sp': ModalViewSp,
      },
    });


    app.config.compilerOptions.whitespace = 'condense'

    app.config.globalProperties.$filters = {
      localize(value) {
        return value.toLocaleString();
      },
      nan2str(value) {
        if (_.isString(value) && value !== 'NaN') {
          return value;
        }
        if (isNaN(value)) {
          return '';
        } else {
          return _.toString(value);
        }
      },
      nan2num(value) {
        if (_.isString(value) && value !== 'NaN') {
          return value;
        }
        if (isNaN(value)) {
          return 0;
        } else {
          return _.toNumber(value);
        }
      },
      nan2dash(value) {
        if (_.isString(value) && value !== 'NaN') {
          return value;
        }
        if (isNaN(value)) {
          return '-';
        } else {
          return value;
        }
      },
    };
    // app.mixin(ProfitAndLoss);
    const appComponent = app.mount(el);
    window.app = appComponent

  }


  const modalEl = document.getElementById('modal-wrapper-el')
  if (modalEl) {

    const modalWrapper = createApp({
      data() {
        return {
          modalProps: {},
          pcMode: document.body.dataset.mode === 'pc',
        };
      },
      methods: {
        async openModal(elementId, e) {
          this.modalProps = {};
          if (e && e.currentTarget.dataset.props) {
            this.modalProps = JSON.parse(e.currentTarget.dataset.props);
          }
          this.$refs.modalWrapper.openModalViewByElementId(elementId);
        },
        closeModal() {
          this.$refs.modalWrapper.closeModalView();
        },
      },
      components: {
        'modal-wrapper': ModalWrapper,
      },
    });

    modalWrapper.config.compilerOptions.whitespace = 'condense'

    const modalWrapperComponent = modalWrapper.mount(modalEl)
    window.modalWrapper = modalWrapperComponent

  }
})